import React, { useEffect, useState } from 'react'
import Button from '../../../../../../common/components/atom/Button/Button'
import { BinIcon } from '../../../../../../common/assets/icons'
import ConfirmationModal from '../../../../../../common/components/atom/ConfirmationModal/ConfirmationModal'
import { useSinglePlanBT } from '../../../../hooks'
import { useNavigate } from 'react-router-dom'
import { PermissionTooltip, useCapability } from '../../../../../rbac'

export default function DeleteBtn({backTo}:{backTo?: string}) {

  const { deletePlanBT:{isSuccess, mutate: deletePlan, isLoading},singlePlanBTQuery:{data}} = useSinglePlanBT()
  const [isModalOpen, setModalOpen] = useState(false)
  // RBAC : suppression du plan entier = planbt.delete (admin).
  const canDelete = useCapability('planbt.delete')
  const naviagte = useNavigate()
  useEffect(() => {
      if(isSuccess && backTo){

      naviagte(backTo ? backTo : '/main/plan-bt')
      }},[isSuccess]) // eslint-disable-line

  if (!data){
    return <></>
  }
  const handleDelete = () => {
    deletePlan({})

  }

  if (isLoading) {
    return <> ... </>
  }


return (
  <>
  <PermissionTooltip allowed={canDelete}>
  <Button
  label="Supprimer"
  IconComponentLeft={() => <BinIcon />}
  onClick={() =>{ if (canDelete) setModalOpen(true)}}
  disabled={!canDelete}
  variant={"tercery"}/>
  </PermissionTooltip>

  <ConfirmationModal
      isOpen={isModalOpen && canDelete}
      type="danger"
      title="Attention"
      message={`Voulez-vous vraiment supprimer le plan ${data.plan_name}?`}
      confirmText="Supprimer"
      cancelText="Annuler"
      onConfirm={handleDelete}
      onCancel={() => setModalOpen(false)}
  />
  </>
)
}
